import { toggleAlert as toggleAlertCommom, toggleAlertModule } from './alert.actions'
import { utilsAxios } from '../../api/axios'
// import { selectedStudentMarking } from '../../components/Dashboard/Assessment copy/Classes/utils'
// import { updateCurrentUnitOfLearningFields } from './classActions'

export const MARKING_TOGGLE_LOADING = 'MARKING_TOGGLE_LOADING'
export const MARKING_TOGGLE_ERROR = 'MARKING_TOGGLE_ERROR'
export const MARKING_UPDATE_FIELDS = 'MARKING_UPDATE_FIELDS'
export const MARKING_BULK_UPDATE_FIELDS = 'MARKING_BULK_UPDATE_FIELDS'
export const MARKING_UPDATE_STUDENTS = 'MARKING_UPDATE_STUDENTS'
export const MARKING_TOGGLE_MODE = 'MARKING_TOGGLE_MODE'
export const MARKING_UPDATE_EVIDENCE_OF_LEARNING = 'MARKING_UPDATE_EVIDENCE_OF_LEARNING'

export const toggleLoading = (loading = false) => ({
	type: MARKING_TOGGLE_LOADING,
	loading
})
export const toggleError = (error = {}) => ({
	type: MARKING_TOGGLE_ERROR,
	error
})
export const updateFieldsStudentTemp = (data, method) => ({
  type: MARKING_UPDATE_STUDENTS,
  payload: { data, method }
})
export const updateBulkFields = (name, value) => ({
  type: MARKING_BULK_UPDATE_FIELDS,
  payload: { name, value }
})
export const updateFields = (name, value) => ({
  type: MARKING_UPDATE_FIELDS,
  payload: { name, value }
})
export const updateEvidenceOfLearning = (data) => ({
  type: MARKING_UPDATE_EVIDENCE_OF_LEARNING,
  payload: { data }
})
export const updateMode = (data) => ({
	type: MARKING_TOGGLE_MODE,
  payload: { data }
})


export const loadStudentMarking = (studentId, unitOfLearnings, unitOfLearningsStudent, typeView, onLoanEL) => {
  return (dispatch) => {
    // const { logMarking, logMarkingOther, lcs } = selectedStudentMarking(
    //   studentId, 
    //   unitOfLearnings, unitOfLearningsStudent, 
    //   typeView, onLoanEL
    // )

    // Asigna la ul estudiante seleccionado a current ul
    dispatch(updateFields('current', JSON.parse(JSON.stringify({ logMarking, logMarkingOther, lcs }))))
    // Asigna la ul estudiante seleccionado a ul tmp
    dispatch(updateFields('temp', JSON.parse(JSON.stringify({ logMarking, logMarkingOther, lcs  }))))

  }
}
const dataBaseMarkingSimple = (currentUL) => {
  return (dispatch) => {
    const ulBase = {
      logMarking: [], 
      logMarkingOther: [], 
      lcs: currentUL?.lcs || []
    }
    dispatch(updateFields('student', JSON.parse(JSON.stringify({}))))
    dispatch(updateFields('current', JSON.parse(JSON.stringify(ulBase))))
    dispatch(updateFields('temp', JSON.parse(JSON.stringify(ulBase))))
  }
}

export const loadDataStudentMarking = (studentId, classId, ulId, { typeView, currentUL }) => {
  if (studentId) {
    return dispatch => {
      dispatch(toggleLoading(true))
      dispatch(dataBaseMarkingSimple(currentUL))
      
      utilsAxios(dispatch, 'POST', `/users/for-marking-student`, { studentId, classId, ulId })
      .then((resp) => {
        if (resp.data.code === 200) {
          if (resp.data.data) {
            const { student, unitOfLearnings } = resp.data.data
            const onLoanEL = (studentId, ulId, idsLcs) =>  dispatch(getEvidenceOfLearningByLcs(studentId, ulId, idsLcs))
            dispatch(loadStudentMarking(studentId, unitOfLearnings, student.unitOfLearnings, typeView, onLoanEL))
            
            // Asigna el estudiante seleccionado 
            dispatch(updateFields('student', JSON.parse(JSON.stringify(student))))
                
            dispatch(toggleLoading(false))
            return
          }
        }

        dispatch(toggleLoading(false))
      }).catch(() => {
        dispatch(toggleLoading(false))
      })
    }
  } else {
    return dispatch => {
      dispatch(toggleLoading(true))
      dataBaseMarkingSimple(dispatch, currentUL)
      dispatch(toggleLoading(false))
    }
  }
}

export const loadDataStudentsMarking = (ids, classId, ulId) => {
  return dispatch => {
    dispatch(updateBulkFields('loading',true))
    dispatch(updateBulkFields('students', []))
    dispatch(updateFieldsStudentTemp([]))
    
    utilsAxios(dispatch, 'POST', `/users/for-marking`, { ids, classId, ulId })
    .then((resp) => {
      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateFieldsStudentTemp(JSON.parse(JSON.stringify(resp.data.data))))
          dispatch(updateBulkFields('loading',false))
          return
        }
      }

      dispatch(updateBulkFields('loading',false))
    }).catch(() => {
      dispatch(updateBulkFields('loading',false))
    })
  }
}

export const marking = (user, classId, ulId, ul, typeMarking)  => {
  return dispatch => {
    // TODO: MAKE REDUX MODE
    dispatch(updateMode({ ...user, status: 'saving' }))
    dispatch(toggleAlertModule(false, null, null, null, null))

    const unitOfLearning = {
      lcs: ul.lcs,
      logMarking: ul.logMarking
    }
    utilsAxios(dispatch, 'POST', `/marking`, {
      userId: user._id, 
      classId, 
      ulId, 
      ul: unitOfLearning, 
      typeMarking
    })
    .then((resp) => {
      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateMode({ ...user, status: 'no change' }))
          dispatch(updateFieldsStudentTemp(resp.data.data, 'PUT'))
          return
        }
      }

    }).catch((error) => {
      if (error.data.type !== "UnAuthorizedImpersonate") {
          // TODO: MAKE REDUX MODE
        dispatch(updateMode({ ...user, status: 'error', ul: unitOfLearning }))
      } else {
          // TODO: MAKE REDUX MODE
        dispatch(updateMode({ ...user, status: 'no change' }))
      }
      dispatch(toggleAlertCommom(true, error.data.title, error.data.icon, error.data.type, error.data.disabledCloseButton))
    })
  }
}

export const bulkMarkingStudent = (students, idClass, idUl, logBulkMarking) => {

  return dispatch => {
    dispatch(updateBulkFields('loading', true))
    dispatch(updateBulkFields('alert', {}))
    dispatch(toggleError({ })) 
    dispatch(toggleAlertCommom(true, 'processing', 'circle-notch', 'LOADING', true))
    
    utilsAxios(dispatch, 'POST', `/marking/bulk`, {
      students: students.map((x) => ( { id: x.id, ul: { _id: x.ul._id, lcs: x.ul.lcs, logMarking: x.ul.logMarking }  } ) ),
      idClass,
      idUl,
      logBulkMarking,
    })
    .then((resp) => {
      if (resp.data.code === 200) {
        if (resp.data.data) {
          const data = resp?.data?.data || {}

          dispatch(updateBulkFields('alert', { type: 'success', message: resp.data.message }))
          dispatch(updateBulkFields('students', []))
          dispatch(updateFieldsStudentTemp(JSON.parse(JSON.stringify(data?.students || [] )), 'BULK'))
          
          dispatch(toggleAlertModule(false, null, null, null, null))  

          const currentUL = data.class.unitOfLearnings.find((x) => String(x._id) === String(idUl))
          // dispatch(updateCurrentUnitOfLearningFields('logBulkMarking', currentUL?.logBulkMarking || []))
          dispatch(updateBulkFields('loading', false))
          dispatch(toggleAlertCommom())
          setTimeout(() => {
            dispatch(updateBulkFields('alert', {}))
          }, 1000)
          return
        }
      }

      dispatch(toggleAlertCommom())
      dispatch(updateBulkFields('loading', false))
    }).catch((error) => {
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      } 
      dispatch(updateBulkFields('loading', false))
    })
  }
}

/** Evidence of learning */
export const getEvidenceOfLearningByLcs = (idStudent, idUl, idsLcs) => {

  return dispatch => {
    dispatch(toggleError({ })) 
    utilsAxios(dispatch, 'POST', `/evidence-of-learning/find-by-student-lcs`, {  idStudent, idUl, idsLcs })
    .then((resp) => {

      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateFields('evidenceOfLearning', resp.data.data))
          return
        }
      }

    }).catch((error) => {
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      }
    })
  }
}
export const getEvidenceOfLearningByLevel = (idStudent, idLc, idUl, idLevel) => {
  return dispatch => {
    dispatch(toggleLoading(true))
    dispatch(toggleError({ })) 

    utilsAxios(dispatch, 'GET', `/evidence-of-learning/find-by-student/${idStudent}/unitOfLearnings/${idUl}/learningContinuum/${idLc}/level/${idLevel}`)
    .then((resp) => {

      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateFields('currentEvidenceOfLearning', resp.data.data))
          dispatch(toggleLoading(false))
          return
        }
      }

      dispatch(toggleLoading(false))
    }).catch((error) => {
      dispatch(toggleLoading(false))
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      }
    })
  }
}
export const updateEvidenceOfLearningByLevel = (idStudent, idLc, idUl, idLevel, item) => {

  return dispatch => {
    dispatch(toggleLoading(true))
    dispatch(toggleError({ })) 

    utilsAxios(dispatch, 'POST', `/evidence-of-learning`, { idStudent, idLc, idUl, idLevel, item })
    .then((resp) => {

      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateEvidenceOfLearning(resp.data.data))
          dispatch(toggleLoading(false))
          return
        }
      }
      dispatch(toggleLoading(false))
    }).catch((error) => {
      dispatch(toggleLoading(false))
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      }
    })
  }
}

/* GROWTH GOALS */
export const getGrowthGoals = (idStudent, idClass, idDr) => {

  return dispatch => {
    dispatch(toggleLoading(true))
    dispatch(toggleError({ })) 

    utilsAxios(dispatch, 'GET', `/growth-goals/${idStudent}/${idClass}/${idDr}`)
    .then((resp) => {
      if (resp.data.code === 200) {
        if (resp.data.data) {
          dispatch(updateFields('growthGoals', resp.data.data.items))
          dispatch(toggleLoading(false))
          return
        }
      }

      dispatch(toggleLoading(false))
    }).catch((error) => {
      dispatch(toggleLoading(false))
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      }
    })
  }
}
export const updateGrowthGoals = (idStudent, idClass, idDr, item) => {

  return dispatch => {
    dispatch(toggleLoading(true))
    dispatch(toggleError({ })) 

    utilsAxios(dispatch, 'POST', `/growth-goals`, {idStudent, idClass, idDr, growthGoals: item})
    .then((resp) => {
      dispatch(toggleLoading(false))
    }).catch((error) => {
      if (error.type === 'form') {
        dispatch(toggleError(error.data)) 
      }
      dispatch(toggleLoading(false))
    })
  }
}